<style scoped>
    @import url("../../../styles/smartControl/alvoFC.scss");
</style>

<template>
    <div class="box_alvoFC">

        <div class="macro_el">
            <div class="tit ml-2">Alvo da capacidade de campo [%]</div>

            <div class="painelSearch">

                <div class="searchBar mt-1 mb-1">

                    <v-autocomplete
                    v-model="alvoSelected"
                    :items="liAlvoLocais"
                    color="rgb(247,215,46)"
                    @update:modelValue="trocarAlvoLocal"
                    ></v-autocomplete>
                    <!-- class="w-100" -->
                </div>
            </div>

            <v-btn v-if="flagBtnUp"
            class="mt-2"
            color='green'
            block 
            :disabled="!flagBtnUp"
            @click="callFather()"
            >
                Atualizar
            </v-btn>
        </div>

    </div>
</template>

<script>

export default {

    props:['agent_unit'],

    data() {
        return {

            // search bar
            liAlvoLocais:["100","95","90","85","80","75","70","65"], // front hardcode
            alvoSelected:'80', // default
            estruturaLocal:{},
            flagBtnUp:false, // controle do botão de atualização
            alvoInit:'80', // default
        }
    },

    methods:{

        trocarAlvoLocal(alvoSelectedFromFront) {
            //console.log('alvoLocal: ',alvoSelectedFromFront)
            this.alvoSelected = alvoSelectedFromFront // up local exib

            // -- SE houve alteração então req up.
            //console.log('[alvoFC][trocaralvoLocal] this.alvoInit: ',this.alvoInit)
            //console.log('[alvoFC][trocaralvoLocal] alvoSelectedFromFront: ',alvoSelectedFromFront)
            if (this.alvoInit != alvoSelectedFromFront) { this.flagBtnUp = true }
            else { this.flagBtnUp = false }
        },

        callFather() {
            // -- componente pai trata a requisição de update.
            // --- pai espera o doc ~estrutura~ completo.
            this.estruturaLocal['target_fc'] = this.alvoSelected // string
            //console.log('[alvoFC] estruturaLocal: ',this.estruturaLocal)
            this.$emit('fromChildUp', this.estruturaLocal) // dict input_last_info
        },
    },

    created() {
        //window.scrollTo(0,0)

        //console.log('[alvoFC] alvo FC:',this.agent_unit['input_last_info']['target_fc'])
        this.alvoSelected = this.agent_unit['input_last_info']['target_fc'] // string
        this.alvoInit = this.alvoSelected
        this.estruturaLocal = this.agent_unit['input_last_info'] // input_last_info != estrutura
    }
}
</script>